<i2g-dialog-base
  [title]="'LABEL.CHANGE_LOGIN_EMAIL' | translate"
  [body]="
    'SETTINGS.CHANGE_EMAIL_DIALOG.VERIFICATION_LINK_LOGIN_EMAIL_CHANGE_MSG'
      | translate
  "
  [primaryButtonText]="'ACTION.CONTINUE' | translate"
  [secondaryButtonText]="'ACTION.CANCEL' | translate"
  [disablePrimaryButton]="emailControl.invalid"
  (primaryButtonClicked)="onPrimaryButtonClicked()"
  (secondaryButtonClicked)="onSecondaryButtonClicked()"
>
  <i2g-input-field
    class="emailField"
    layoutDirection="column"
    [focusableTrigger$]="focusableTrigger$"
    [fieldControl]="emailControl"
    [label]="'LABEL.NEW_EMAIL' | translate"
    [placeholder]="'SETTINGS.CHANGE_EMAIL_DIALOG.PLACEHOLDER' | translate"
    [description]="'SETTINGS.CHANGE_EMAIL_DIALOG.HELP_TEXT' | translate"
    (inputKeyup)="onEmailKeyUp($event)"
  >
  </i2g-input-field>
</i2g-dialog-base>
